import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import {
  HiOutlineSparkles,
  HiOutlineHeart,
  HiOutlineTruck,
  HiOutlineChatBubbleLeftRight,
  HiOutlineShoppingBag,
  HiOutlineClipboardDocumentList,
  HiOutlineChatBubbleBottomCenterText,
  HiOutlineGift,
  HiOutlineMapPin,
  HiOutlineCalendarDays,
} from 'react-icons/hi2';
import Icon from '../../utils/Icon';
import { fetchAllProducts } from '../../controllers/productController';
import { aboutImage } from '../../assets/placeholder';
import heroBackgroundImage from '../../assets/Massa de cookie com gotas de chocolate.png';
import Button from '../../components/Button';
import SectionContainer from '../../components/SectionContainer';
import ProductCard from '../../components/ProductCard';
import SocialLinks from '../../components/SocialLinks';
import FreteNote from '../../components/FreteNote';
import {
  HeroSection,
  HeroContainer,
  HeroContent,
  HeroTag,
  HeroBrand,
  HeroSubtitle,
  HeroActions,
  FeaturesBar,
  FeaturesContainer,
  FeatureItem,
  FeatureIcon,
  FeatureText,
  ProductsGrid,
  AboutSection,
  AboutContainer,
  AboutImageWrapper,
  AboutContent,
  AboutTag,
  AboutTitle,
  AboutDescription,
  Divider,
  HowSection,
  HowContainer,
  HowHeader,
  HowTag,
  HowTitle,
  HowGrid,
  HowCard,
  HowStep,
  HowIcon,
  HowCardTitle,
  HowCardDesc,
  LocationSection,
  LocationContainer,
  LocationInfo,
  LocationTag,
  LocationTitle,
  LocationAddress,
  LocationHint,
  LocationActions,
  LocationBadges,
  LocationBadge,
  LocationMapWrapper,
} from './styles';

const features = [
  {
    icon: HiOutlineSparkles,
    title: '100% Artesanal',
    desc: 'Ingredientes selecionados, feitos à mão',
  },
  {
    icon: HiOutlineHeart,
    title: 'Feito com Carinho',
    desc: 'Dedicação especial em cada doce',
  },
  {
    icon: HiOutlineTruck,
    title: 'Entrega em Muriaé',
    desc: 'Frete fixo de R$ 10 na cidade',
  },
  {
    icon: HiOutlineChatBubbleLeftRight,
    title: 'Sob Encomenda',
    desc: 'Pedidos personalizados via WhatsApp',
  },
];

const howSteps = [
  {
    icon: HiOutlineShoppingBag,
    title: 'Escolha os produtos',
    desc: 'Navegue pelo catálogo e selecione seus favoritos.',
  },
  {
    icon: HiOutlineClipboardDocumentList,
    title: 'Selecione gramatura',
    desc: 'Escolha o peso e a quantidade de cada item.',
  },
  {
    icon: HiOutlineChatBubbleBottomCenterText,
    title: 'Finalize pelo WhatsApp',
    desc: 'Seu pedido é enviado direto para o nosso WhatsApp.',
  },
  {
    icon: HiOutlineGift,
    title: 'Receba ou retire',
    desc: 'Entregamos em Muriaé ou retire no local.',
  },
];

const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Avenida+do+Contorno+15+Dornelas+Muriae+MG';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3713.0!2d-42.37!3d-21.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjHCsDA3JzQ4LjAiUyA0MsKwMjInMTIuMCJX!5e0!3m2!1spt-BR!2sbr!4v1';

const Home: React.FC = () => {
  const products = fetchAllProducts();

  return (
    <main>
      <HeroSection id="hero" aria-label="Apresentação da marca" $backgroundImage={heroBackgroundImage}>
        <HeroContainer>
          <HeroContent>
            <HeroTag>Doces Artesanais</HeroTag>
            <HeroBrand>
              Momentos Doces
              <span>Começam Aqui.</span>
            </HeroBrand>
            <HeroSubtitle>
              Conheça o sabor autêntico das nossas balas e biscoitos artesanais.
              Ingredientes frescos, receitas tradicionais e muito carinho em cada preparo.
            </HeroSubtitle>
            <HeroActions>
              <Button href="https://wa.me/5532988583597" size="lg">
                <span style={{ color: '#25D366' }}><Icon icon={FaWhatsapp} /></span> Fazer Pedido
              </Button>
              <Button href="#catalogo" variant="outline" size="lg" target="_self">
                Ver Produtos
              </Button>
            </HeroActions>
            <FreteNote variant="hero" />
          </HeroContent>
        </HeroContainer>
      </HeroSection>

      <FeaturesBar aria-label="Nossos diferenciais">
        <FeaturesContainer>
          {features.map((feature, index) => (
            <FeatureItem key={feature.title} style={{ animationDelay: `${index * 0.1}s` }}>
              <FeatureIcon aria-hidden="true">
                <Icon icon={feature.icon} />
              </FeatureIcon>
              <FeatureText>
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </FeatureText>
            </FeatureItem>
          ))}
        </FeaturesContainer>
      </FeaturesBar>

      <HowSection id="como-funciona" aria-label="Como funciona">
        <HowContainer>
          <HowHeader>
            <HowTag>Simples e Rápido</HowTag>
            <HowTitle>Como Funciona</HowTitle>
          </HowHeader>
          <HowGrid>
            {howSteps.map((step, i) => (
              <HowCard key={step.title} style={{ animationDelay: `${i * 0.1}s` }}>
                <HowStep aria-hidden="true">{i + 1}</HowStep>
                <HowIcon aria-hidden="true"><Icon icon={step.icon} /></HowIcon>
                <HowCardTitle>{step.title}</HowCardTitle>
                <HowCardDesc>{step.desc}</HowCardDesc>
              </HowCard>
            ))}
          </HowGrid>
        </HowContainer>
      </HowSection>

      <SectionContainer
        id="catalogo"
        title="Nossos Produtos"
        subtitle="Descubra nossa seleção de doces artesanais, preparados com ingredientes frescos e receitas de família"
      >
        <Divider />
        <ProductsGrid>
          {products.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </ProductsGrid>
      </SectionContainer>

      <AboutSection id="sobre" aria-label="Nossa história">
        <AboutContainer>
          <AboutImageWrapper>
            <img
              src={aboutImage}
              alt="Viviane preparando doces artesanais"
              loading="lazy"
              decoding="async"
            />
          </AboutImageWrapper>
          <AboutContent>
            <AboutTag>Nossa História</AboutTag>
            <AboutTitle>
              Viviane Balas e<br />
              Biscoitos <span>Artesanais</span>
            </AboutTitle>
            <AboutDescription>
              Cada receita carrega a tradição e o cuidado de quem produz à mão.
              Nossas balas e biscoitos artesanais são feitos com ingredientes
              frescos e criteriosamente selecionados, garantindo qualidade e
              sabor em cada mordida.
            </AboutDescription>
            <AboutDescription>
              Da nossa cozinha para a sua mesa, entregamos doçura e afeto em
              cada encomenda. Experimente o verdadeiro sabor do artesanal.
            </AboutDescription>
            <Button href="https://wa.me/5532988583597" variant="primary" size="md">
              <span style={{ color: '#25D366' }}><Icon icon={FaWhatsapp} /></span> Fale Conosco
            </Button>
          </AboutContent>
        </AboutContainer>
      </AboutSection>

      <LocationSection id="localizacao" aria-label="Localização">
        <LocationContainer>
          <LocationInfo>
            <LocationTag>Localização</LocationTag>
            <LocationTitle>
              Retire Seu Pedido<br />
              <span style={{ fontStyle: 'italic', fontWeight: 400, fontSize: '0.75em' }}>
                ou receba em casa
              </span>
            </LocationTitle>
            <LocationAddress>
              <strong>Viviane Balas e Biscoitos Artesanais</strong>
              Avenida do Contorno, 15 — Dornelas<br />
              CEP 36884-211 · Muriaé — MG
            </LocationAddress>
            <LocationHint>
              Prefere retirar? Estamos em Dornelas, Muriaé. Combine pelo WhatsApp!
            </LocationHint>
            <LocationActions>
              <Button
                href={GOOGLE_MAPS_URL}
                variant="outline-dark"
                size="md"
              >
                <Icon icon={HiOutlineMapPin} /> Abrir no Maps
              </Button>
              <Button href="https://wa.me/5532988583597" variant="primary" size="md">
                <span style={{ color: '#25D366' }}><Icon icon={FaWhatsapp} /></span> Pedir pelo WhatsApp
              </Button>
            </LocationActions>
            <LocationBadges>
              <LocationBadge>
                <Icon icon={HiOutlineMapPin} /> Retirada no local
              </LocationBadge>
              <LocationBadge>
                <Icon icon={HiOutlineTruck} /> Entregas em Muriaé
              </LocationBadge>
              <LocationBadge>
                <Icon icon={HiOutlineCalendarDays} /> Sob encomenda
              </LocationBadge>
            </LocationBadges>
          </LocationInfo>
          <LocationMapWrapper>
            <iframe
              src={MAPS_EMBED_URL}
              title="Localização de Viviane Balas e Biscoitos Artesanais no mapa"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </LocationMapWrapper>
        </LocationContainer>
      </LocationSection>

      <SectionContainer
        id="contato"
        title="Fale Conosco"
        subtitle="Acompanhe nossas novidades nas redes sociais ou faça seu pedido diretamente pelo WhatsApp"
        bgColor="#F2D5D0"
      >
        <Divider />
        <SocialLinks />
      </SectionContainer>
    </main>
  );
};

export default Home;
